module.exports = __webpack_public_path__ + "static/media/sf-test-18.c9d9fae6.mp3";